import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from './actions';

class EnableSwitch extends Component {
    onClick(use) {
        this.props.dispatch(Action.do('useTeamNameStacking', !use));
    }
    render() {
        const {teamNameStacking} = this.props;

        return (
            <div className="lineup-control">
                <div className="lineup-control-holder">
                    <div className="filter-btn-group">
                        <button
                            type="button"
                            className={!teamNameStacking.isEnabled() ? 'active' : ''}
                            onClick={(() => this.onClick(teamNameStacking.isEnabled())).bind(this)}
                        >
                            Off
                        </button>
                        <button
                            type="button"
                            className={teamNameStacking.isEnabled() ? 'active' : ''}
                            onClick={(() => this.onClick(teamNameStacking.isEnabled())).bind(this)}
                        >
                            On
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {teamNameStacking} = state;

    return {
        teamNameStacking,
    };
}

export default connect(mapStatesToProps)(EnableSwitch);
